<h4>Categorizers</h4>
<table>
  <tbody>
    @for (cat of categorizations; track cat) {
      <tr>
        <td class="categorizer">
          <app-categorizer-label [categorizer]="cat.categorizer.toLowerCase()"></app-categorizer-label>
        </td>
        <td class="cateogry">{{cat.category}}</td>
      </tr>
    }
  </tbody>
</table>
